<template>
  <div id="app">
    <suspense>
      <router-view />
    </suspense>
    <div id="message-box" />

    <div id="mloading" class="loading">
      <!-- <div class="loadingio-spinner-dual-ball-p4fazz803e">
        <div class="ldio-z76ep1av69">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div> -->
      <div class="loading-cover" />
      <div class="loading-svg">
        <div class="effect-1 effects" />
      </div>
    </div>
    <modals-container />
    <dialog-wrapper />
    <div class="fake-click" />

    <div id="msg-box-nps" class="msg-box-nps" style="display: none">
      <div id="msg-center-nps" class="form-popup-nps msg-center-nps">
        <iframe id="msg-content-nps" frameborder="0" />
      </div>
    </div>
    <div class="flex-row">
      <!-- Icon ava chat bot -->
      <AvaClient v-if="ifOffAva == false" />
      <!-- Box chat AVA -->
      <div id="aibot" style="position: fixed; right: 0px; bottom: 0px; z-index: 9999999999; cursor: pointer" />
      <!-- <LiveChat v-if="isOffLiveChat == false" /> -->
    </div>
  </div>
</template>

<script>
import {DialogWrapper} from 'vue3-promise-dialog';
import AvaClient from './views/ava/avaClient.vue';
import LiveChat from './views/liveChat/LiveChat.vue';
export default {
  components: {
    DialogWrapper,
    AvaClient,
    LiveChat,
  },
  data() {
    return {
      isOffLiveChat: window._off_livechat,
      ifOffAva: window._off_ava,
    };
  },
  computed: {},
  watch: {},
  created() {},

  mounted() {
    const me = this;
    me.initEnterSameTab();
  },
  methods: {
    /**
     * next control khi ấn Enter
     */
    initEnterSameTab() {
      const me = this;

      window.addEventListener('keydown', function (e) {
        if (e.which === 13 && !e.shiftKey) {
          const tag = e.target.tagName.toLowerCase();
          if (['button', 'a'].indexOf(tag) > -1) {
            return;
          }

          if ('textarea' == tag && e.shiftKey) {
            return;
          }
          // Nếu sự kiện xảy ra ở grid thì không bắt sự kiện ở hàm này nữa. Trong grid đã xử lý.
          // Thêm kiểm tra phải là control nhập liệu trong bođy thì mới bỏ qua
          if (e.target.closest('.ms-grid-viewer') && e.target.closest('tbody')) {
            return;
          }
          // ntphong 27/5/2021 - với control có class remain-focus-when-enter thì không focus sang control tiếp theo khi ấn enter
          if (e.target.closest('.remain-focus-when-enter')) {
            return;
          }
          const focusable = me.$ms.commonFn.focusNextControl(e.target);
          if (focusable) {
            e.preventDefault();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
